import { render, staticRenderFns } from "./ProductAreas.vue?vue&type=template&id=cd8e3e42&scoped=true"
import script from "./ProductAreas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAreas.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8e3e42",
  null
  
)

export default component.exports